import { type ReactNode, useId } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';

type DrawerProps = {
    title?: string;
    isOpen: boolean;
    hide: () => void;
    content: ReactNode;
};

export type DrawerContentProps = {
    hide: () => void;
};

const Drawer = ({ isOpen, hide, title = 'Filters', content }: DrawerProps) => {
    const titleId = useId();

    return (
        <Offcanvas show={isOpen} onHide={hide} placement="end" aria-labelledby={titleId}>
            <Offcanvas.Header closeButton>
                <Offcanvas.Title id={titleId}>{title}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>{content}</Offcanvas.Body>
        </Offcanvas>
    );
};

export default Drawer;
